export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11511.e617035a.jpg";